<template>
  <div>

    <u-modal id="createServer" link="Создать сервис" title="Создать сервис" :isModalOpen="isModalOpen">
      <form @submit.prevent="newService">
        <div class="mb-3">
          <label for="serviceName">Название</label>
          <input type="text" name="serviceName" v-model="formData.name" class="form-control" id="serviceName">
        </div>
        <button type="submit" class="btn btn-primary">Создать</button>
      </form>
    </u-modal>
    <button type="submit" class="btn btn-primary" @click="isModalOpen=true">Создать сервис</button>
  </div>
</template>

<script setup>
import {defineProps, ref} from 'vue'
const props  = defineProps({
  projectId: String,
})

import {useServiceStore} from '@/store/services'
const serviceStore = useServiceStore()

// create service
const formData = ref({
  name: "",
})
const isModalOpen = ref(false)

async function newService () {
  await serviceStore.create({
    projectId: props.projectId,
    ...formData.value
  })
  isModalOpen.value = false
  await serviceStore.getList(props.projectId)
}

</script>
